import { render } from "./Event-index.vue?vue&type=template&id=1be8a208"
import script from "./Event-index.vue?vue&type=script&lang=js"
export * from "./Event-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__